import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Sidebar from './components/Sidebar';
import { useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Planning from './pages/Planning';
import Vendors from './pages/Vendors';
import Budget from './pages/Budget';
import Login from './pages/Login';

import NotFound from './pages/NotFound';

import Settings from './pages/Settings';
import EventSchedule from './pages/EventSchedule';


import SeatingChart from './pages/SeatingChart';
import TravelAccommodation from './pages/TravelAccommodation';
import ProtectedRoute from './components/ProtectedRoute';
import { AppProvider, useAppContext } from './context/AppContext';
import './index.css';
import Redirect from './components/Redirect';
import SampleDataForm from './pages/AddSampleData';


const Notification = () => {
  const { notification, clearNotification } = useAppContext();
  useEffect(() => {
    if (notification) {
      const timeout = setTimeout(() => {
        clearNotification();
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [notification, clearNotification]);
  if (!notification) return null;
  return (
    <div className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded shadow-lg text-white bg-${notification.type === 'success' ? 'success' : notification.type === 'danger' ? 'danger' : notification.type === 'info' ? 'info' : 'primary'}`}
      onClick={clearNotification}
      role="alert"
      style={{ cursor: 'pointer' }}
    >
      {notification.message}
    </div>
  );
};


function AppContent() {
  const location = useLocation();
  const hideLayout = location.pathname === '/login';
  return (
    <>
      <Notification />
      {hideLayout ? (
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      ) : (
        <div className="flex">
          <Sidebar className="hidden md:block" />
          <div className="flex-1 ml-0 md:ml-64 min-h-screen">

            <div className="container mx-auto px-4 mt-14 md:mt-0">
              <Routes>
                <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/dashboard" element={<Navigate to="/" replace />} />
                <Route path="/id/:id" element={<Redirect />} />
                <Route path="/id/:id/:userEmail/:token" element={<Redirect />} />
                <Route path="/planning" element={<ProtectedRoute><Planning /></ProtectedRoute>} />
                <Route path="/vendors" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
                <Route path="/budget" element={<ProtectedRoute><Budget /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                <Route path="/event-schedule" element={<ProtectedRoute><EventSchedule /></ProtectedRoute>} />
                <Route path="/seating-chart" element={<ProtectedRoute><SeatingChart /></ProtectedRoute>} />
                <Route path="/travel-accommodation" element={<ProtectedRoute><TravelAccommodation /></ProtectedRoute>} />
                <Route path="*" element={<NotFound />} />
                <Route path="/sample-data" element={<SampleDataForm />} />
              </Routes>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <Router>
        <AppContent />
      </Router>
    </AppProvider>
  );
}

export default App;
